import { useMemo } from 'react';
import { Box, Flex, Icon, Text, useColorModeValue } from '@chakra-ui/react';
import BarChart from 'components/charts/BarChart';
import Card from 'components/card/Card';
import { RiArrowUpSFill } from 'react-icons/ri';
import { useFinance } from 'contexts/FinanceContext';
import { formatAmount, groupByDay } from 'lib/finance';
import { barChartOptionsDailyTraffic } from 'variables/charts';

export default function FinanceDailyExpenses(props: { [x: string]: any }) {
  const { ...rest } = props;
  const { transactions, totals, currencySymbol } = useFinance();
  const textColor = useColorModeValue('secondaryGray.900', 'white');

  const dailyData = useMemo(() => groupByDay(transactions), [transactions]);
  const todayExpense = dailyData[dailyData.length - 1]?.expense ?? 0;

  const chartData = useMemo(
    () => [{ name: 'Expenses', data: dailyData.map((d) => d.expense) }],
    [dailyData]
  );

  const chartOptions = useMemo(
    () => ({
      ...barChartOptionsDailyTraffic,
      xaxis: {
        ...barChartOptionsDailyTraffic.xaxis,
        categories: dailyData.map((d) => d.label),
      },
    }),
    [dailyData]
  );

  return (
    <Card alignItems="center" flexDirection="column" w="100%" {...rest}>
      <Flex justify="space-between" align="start" px="10px" pt="5px" w="100%">
        <Flex flexDirection="column" align="start" me="20px">
          <Flex w="100%">
            <Text me="auto" color="secondaryGray.600" fontSize="sm" fontWeight="500">
              Daily Expenses
            </Text>
          </Flex>
          <Flex align="end">
            <Text color={textColor} fontSize="34px" fontWeight="700" lineHeight="100%">
              {currencySymbol}
              {formatAmount(todayExpense)}
            </Text>
            <Text ms="6px" color="secondaryGray.600" fontSize="sm" fontWeight="500">
              Today
            </Text>
          </Flex>
        </Flex>
        <Flex align="center">
          <Icon as={RiArrowUpSFill} color="green.500" />
          <Text color="green.500" fontSize="sm" fontWeight="700">
            {totals.transactionCount}
          </Text>
        </Flex>
      </Flex>
      <Box h="240px" mt="auto" w="100%">
        <BarChart chartData={chartData} chartOptions={chartOptions} />
      </Box>
    </Card>
  );
}
